import { render } from "./LabelsView.vue?vue&type=template&id=8252032a&scoped=true"
import script from "./LabelsView.vue?vue&type=script&lang=js"
export * from "./LabelsView.vue?vue&type=script&lang=js"

import "./LabelsView.vue?vue&type=style&index=0&id=8252032a&lang=scss&scoped=true"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8252032a"]])

export default __exports__